import { forwardRef } from "react";
import { graphql, useFragment } from "react-relay";

import type { ContentItemRenderVariantProps } from "~/components/content/content-item-render/types";
import type { homeSuperSplashLiveSecondaryContentItemContent$key } from "~/queries/__generated__/homeSuperSplashLiveSecondaryContentItemContent.graphql";

import {
  ActionBar,
  Container,
  Content,
  Headline,
  HeadlineContainer,
  StyledEntityLink,
} from "./styles";

export type Props = {
  reference: homeSuperSplashLiveSecondaryContentItemContent$key;
  variantProps?: ContentItemHomeSuperSplashLiveSecondaryVariantProps;
} & ContentItemRenderVariantProps;

export type ContentItemHomeSuperSplashLiveSecondaryVariantProps = {
  withComment?: boolean;
};

export const ContentItemHomeSuperSplashLiveSecondary = forwardRef<HTMLDivElement, Props>(
  ({ className, onClick, provider, reference: reference_, variantProps }, reference) => {
    const content = useFragment(
      graphql`
        fragment homeSuperSplashLiveSecondaryContentItemContent on Content {
          ...entityLink
          entityId
        }
      `,
      reference_,
    );

    return (
      <Container className={className} ref={reference}>
        <Content>
          <StyledEntityLink reference={content} onClick={() => onClick?.(content.entityId)}>
            <HeadlineContainer>
              <Headline>
                {provider.headline({
                  hideTooltip: true,
                  preferSocialHeadline: true,
                  skipHighlight: true,
                })}
              </Headline>
              {provider.liveTag()}
            </HeadlineContainer>
          </StyledEntityLink>
          <ActionBar>
            {provider.actionBar({
              commentVariant: "reverse",
              isBookmarkVisible: false,
              isCommentsVisible: variantProps?.withComment ?? false,
            })}
          </ActionBar>
        </Content>
      </Container>
    );
  },
);

ContentItemHomeSuperSplashLiveSecondary.displayName = "ContentItemHomeSuperSplashLiveSecondary";
